import React, { useState, useMemo } from 'react';
import CalcShell from '../CalcShell';

export default function TimeDurationCalc() {
  const [tab, setTab] = useState('duration');
  return (
    <CalcShell look="cnet" title="Time Duration Calculator" subtitle="Compute a duration between two clock times or a full duration between two calendar dates.">
      <div className="flex gap-2 mb-5 flex-wrap">
        {[['duration','Between Two Times'],['dates','Between Two Dates']].map(([v,l]) => (
          <button key={v} onClick={() => setTab(v)} className={`px-4 py-2 rounded-full text-sm font-semibold ${tab === v ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-700'}`} data-testid={`td-tab-${v}`}>{l}</button>
        ))}
      </div>
      {tab === 'duration' ? <Duration /> : <BetweenDates />}
    </CalcShell>
  );
}

function Duration() {
  const [h1, setH1] = useState(9); const [m1, setM1] = useState(0); const [s1, setS1] = useState(0);
  const [h2, setH2] = useState(17); const [m2, setM2] = useState(30); const [s2, setS2] = useState(0);
  const r = useMemo(() => {
    let t1 = h1*3600 + m1*60 + s1; let t2 = h2*3600 + m2*60 + s2;
    let sec = t2 - t1; if (sec < 0) sec += 86400;
    const H = Math.floor(sec/3600); const M = Math.floor((sec%3600)/60); const S = sec%60;
    return { H, M, S, dec: sec/3600 };
  }, [h1, m1, s1, h2, m2, s2]);
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div>
        <h4 className="font-semibold mb-2">Start</h4>
        <div className="grid grid-cols-3 gap-3">
          <div className="field"><label>H</label><input type="number" value={h1} onChange={e => setH1(+e.target.value || 0)}/></div>
          <div className="field"><label>M</label><input type="number" value={m1} onChange={e => setM1(+e.target.value || 0)}/></div>
          <div className="field"><label>S</label><input type="number" value={s1} onChange={e => setS1(+e.target.value || 0)}/></div>
        </div>
        <h4 className="font-semibold mb-2 mt-3">End</h4>
        <div className="grid grid-cols-3 gap-3">
          <div className="field"><label>H</label><input type="number" value={h2} onChange={e => setH2(+e.target.value || 0)}/></div>
          <div className="field"><label>M</label><input type="number" value={m2} onChange={e => setM2(+e.target.value || 0)}/></div>
          <div className="field"><label>S</label><input type="number" value={s2} onChange={e => setS2(+e.target.value || 0)}/></div>
        </div>
      </div>
      <div>
        <div className="result-panel mb-3"><div className="result-title">Duration</div><div className="result-value">{r.H}h {r.M}m {r.S}s</div></div>
        <table className="data-table"><tbody><tr><td>Decimal hours</td><td className="text-right">{r.dec.toFixed(3)}</td></tr></tbody></table>
      </div>
    </div>
  );
}

function BetweenDates() {
  const [s, setS] = useState(() => new Date().toISOString().slice(0,16));
  const [e, setE] = useState(() => { const d = new Date(); d.setDate(d.getDate() + 30); return d.toISOString().slice(0,16); });
  const r = useMemo(() => {
    const totalSec = Math.max(0, (new Date(e).getTime() - new Date(s).getTime()) / 1000);
    const years = totalSec / (365.25 * 86400);
    const months = totalSec / (30.4375 * 86400);
    const days = Math.floor(totalSec / 86400);
    const H = Math.floor((totalSec % 86400) / 3600);
    const M = Math.floor((totalSec % 3600) / 60);
    return { totalSec, years, months, days, H, M };
  }, [s, e]);
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div>
        <div className="field"><label>Start Date &amp; Time</label><input type="datetime-local" value={s} onChange={ev => setS(ev.target.value)} data-testid="td-start"/></div>
        <div className="field"><label>End Date &amp; Time</label><input type="datetime-local" value={e} onChange={ev => setE(ev.target.value)} data-testid="td-end"/></div>
      </div>
      <div>
        <div className="result-panel mb-3"><div className="result-title">Duration</div><div className="result-value" data-testid="td-dur">{r.days}d {r.H}h {r.M}m</div></div>
        <table className="data-table"><tbody>
          <tr><td>Total seconds</td><td className="text-right font-mono">{r.totalSec.toFixed(0)}</td></tr>
          <tr><td>Total minutes</td><td className="text-right font-mono">{(r.totalSec/60).toFixed(1)}</td></tr>
          <tr><td>Total hours</td><td className="text-right font-mono">{(r.totalSec/3600).toFixed(2)}</td></tr>
          <tr><td>Total weeks</td><td className="text-right font-mono">{(r.totalSec/(86400*7)).toFixed(3)}</td></tr>
          <tr><td>Approx. months (30.44 d)</td><td className="text-right font-mono">{r.months.toFixed(3)}</td></tr>
          <tr><td>Approx. years (365.25 d)</td><td className="text-right font-mono">{r.years.toFixed(4)}</td></tr>
        </tbody></table>
      </div>
    </div>
  );
}
